import { AnchorHTMLAttributes } from 'react'
import { DisplayProps, MarginProps, PositionProps } from 'styled-system'

import { TestIdProps } from 'designSystem/types/propTypes'

import { COLOR } from 'designSystem/foundations/constants/color'
import { FONT_SIZE } from 'designSystem/foundations/constants/fontSize'
import { FONT_WEIGHT } from 'designSystem/foundations/constants/fontWeight'
import { LINE_HEIGHT } from 'designSystem/foundations/constants/lineHeight'

import { TextSize } from '../PDSText/PDSText'
import INTERNALxAnchor from '../internal/elements/INTERNALxAnchor'

type LinkVariant = 'primary' | 'secondary'

type BaseProps = AnchorHTMLAttributes<HTMLAnchorElement> &
  DisplayProps &
  MarginProps &
  PositionProps &
  TestIdProps

type Props = {
  size?: TextSize
  text?: string
  to?: string
  variant?: LinkVariant
} & BaseProps

export default function PDSLink({
  className,
  size = 'md',
  testId,
  text,
  to,
  variant = 'primary',
  ...props
}: Props) {
  const sizeStyles = TEXT_LINK_SIZE[size] ?? TEXT_LINK_SIZE.md
  const variantStyles = TEXT_LINK_STYLE[variant] ?? TEXT_LINK_STYLE.primary

  return (
    <INTERNALxAnchor
      {...sizeStyles}
      {...variantStyles}
      {...props}
      className={`link ${className}`}
      fontWeight={FONT_WEIGHT.semibold}
      href={to}
      testId={testId}
      textDecoration="underline"
    >
      {text}
    </INTERNALxAnchor>
  )
}

const TEXT_LINK_SIZE = {
  sm: {
    fontSize: FONT_SIZE.fs12,
    lineHeight: LINE_HEIGHT.lh16,
  },
  md: {
    fontSize: FONT_SIZE.fs14,
    lineHeight: LINE_HEIGHT.lh20,
  },
  lg: {
    fontSize: FONT_SIZE.fs16,
    lineHeight: LINE_HEIGHT.lh24,
  },
}

const TEXT_LINK_STYLE = {
  primary: {
    color: COLOR.textLink,
  },
  secondary: {
    color: COLOR.textSecondary,
  },
}
